import ListHeaderComponent from './list-header-component';

/***
 * The header at the top of a list.
 *
 * There are 2 optional arrays that can passed in:
 *
 * columnSize   - a n array of class names that will be added the corresponding column. For example, ['sm', 'sm', 'lg']
 *                will add 'sm' classes to the first 2 columns, an 'lg' class to the 3rd column, and no additional
 *                classes to the remaining columns.
 * showSort     - a list of boolean values that dictate whether a column should show the sort icons. Defaults to
 *                false, so passing in [true, false, true] will allow for sorting of the first and third columns and
 *                hide the sort icon for all other columns.
 *
 */
const ListHeader = angular
    .module('FacilityData.Common.ListHeader', [])
    .component('listHeader', ListHeaderComponent)
    .name;

export default ListHeader;


// WEBPACK FOOTER //
// ./app/common/list-header/list-header.js